/**
 * Επαναπροσπάθεια για δεδομένα που ζητούνται κατά το SSR.
 *
 * Στο edge runtime ένα upstream subrequest μπορεί να κοπεί στη μέση
 * ("Network connection lost."). Χωρίς retry, μια στιγμιαία διακοπή γίνεται
 * ολόκληρη σελίδα σφάλματος για τον επισκέπτη.
 */
export async function retryAsync<T>(
  fn: () => Promise<T>,
  attempts = 4,
  delayMs = 150,
): Promise<T> {
  let lastError: unknown;
  for (let i = 0; i < attempts; i += 1) {
    try {
      return await fn();
    } catch (error) {
      lastError = error;
      if (i < attempts - 1) {
        await new Promise((r) => setTimeout(r, delayMs * (i + 1)));
      }
    }
  }
  throw lastError;
}
